export function formatCurrencyIDR(nominal: number) {
    var rounded = Math.floor(nominal);
    var thousandSeparation = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `Rp. ${thousandSeparation}`;
}